<router-outlet><app-spinner></app-spinner></router-outlet>

<simple-notifications [options]="options"></simple-notifications>
